import {
  Box,
  Checkbox,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";

const FilterBar = ({
  filterValue,
  onFilterChange,
  uniqueValues,
  filterLabel = "Filter by Customer ID",
  allLabel = "All Customers",
  showSelectAll = false,
  isAllSelected = false,
  hasSelection = false,
  onSelectAll,
  selectedCount = 0,
  totalCount = 0,
}) => {
  return (
    <Box display="flex" gap={2} alignItems="center">
      <FormControl size="small" sx={{ minWidth: 200 }}>
        <InputLabel>{filterLabel}</InputLabel>
        <Select
          value={filterValue}
          onChange={(e) => onFilterChange(e.target.value)}
          label={filterLabel}
        >
          <MenuItem value="">{allLabel}</MenuItem>
          {uniqueValues.map((value) => (
            <MenuItem key={value} value={value}>
              {value}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {showSelectAll && totalCount > 0 && (
        <Box display="flex" alignItems="center" gap={1}>
          <Checkbox
            checked={isAllSelected}
            indeterminate={hasSelection && !isAllSelected}
            onChange={(e) => onSelectAll(e.target.checked)}
          />
          <Typography variant="body2">
            Select All ({selectedCount}/{totalCount})
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default FilterBar;
